import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { Popover, PopoverHeader, PopoverBody } from "reactstrap"
import axios from 'axios'

import env from '../../env/src_config'
import { headersState, tokenState } from '../../recoil/recoil'
import { isNull } from '../../izUtils'
import { axiosError } from '../../helpers/response'

const DictionaryInfoButton = ({ code, id , color = "#000000", marginBottom = null }) => {
    const Navigate = useNavigate();

    const headers = useRecoilValue(headersState);
    const token = useRecoilValue(tokenState);
    const [content, setContent] = useState("");
    const [popover, setPopover] = useState(false)

    const HtmlContentToggle = () => {
        if (popover) {
            setPopover(!popover);
            return;
        }

        axios.get(env.api + '/api/dictionary/get/' + code, {headers}).then(response => {
            setPopover(!popover)
            if (!isNull(response.data.content)) setContent(response.data.content);
        }).catch(error => {
            axiosError(error, Navigate);
        });
    }

    return (
        <>
            <button
                id={"Popover" + id?.replaceAll('.', '-')}
                className="d-flex justify-content-center align-items-center"
                style={{ backgroundColor: 'transparent', border: 'none', padding: '0px 6px', cursor: 'pointer' }}
            >
                <i className= "icon-info-alt" style={{ fontSize: '20px', color: color, marginBottom: marginBottom ? "0.2rem" : undefined }}></i>
            </button>
            <Popover
                placement="right"
                isOpen={popover}
                target={"Popover" + id?.replaceAll('.', '-')}
                toggle={HtmlContentToggle}
                trigger="focus"
            >
            <PopoverHeader>{token?.parsedToken?.type === 'admin' ? code : ''}</PopoverHeader>
                <PopoverBody>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                </PopoverBody>
            </Popover>
        </>
    )
}

export default DictionaryInfoButton